import React from "react";
import Image from "next/future/image";
import Link from "next/link";
import Collapsible from "react-collapsible";
import sanitizeHtml from "sanitize-html";
import PayrollContentStyles from "./PayrollContentStyles";
import Testimonials from "@components/SmallBusinessTaxesPage/Testimonials";
import FaqComponent from "@/components/Bookkeeping/FaqComponent";

const PayrollContentComponent = ({
  data: {
    acf: { common_content },
  },
  buttonAction,
  acf,
  blogModuleData
}) => {
  const { faqs, get_started, maximum_refund, testimonial, what_you_get } =
    common_content;

  const stars = 5;

  const sanitizeSettings = {
    allowedTags: ["p", "h2", "strong", "span"],
    allowedAttributes: {
      p: [""],
    },
  };

  const blogLinks = [
    "/blog/small-business-payroll",
    "/blog/make-payroll-more-efficient",
    "/blog/payroll-tax-return",
  ];

  const cardTitles = [
    ["Paying Employees:", "How to Run Payroll for Your Small Business"],
    ["5 Tips to Make Payroll", "More Efficient"],
    ["Paying Employees:", " Understanding the Payroll Tax Return"],
  ];

  return (
    <PayrollContentStyles>
      {/* Payroll Cards Section */}
      <section className="payroll-cards">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="cards-section-title">{acf.bn_title}</div>
              <div className="cards-container">
                {acf.business_needs.map((card, index) => (
                  <div className="card-section" key={index}>
                    <div className="icon-bubble">
                      <img
                        className="card-icon"
                        src={card.icon.url}
                        alt="icon"
                        width="500px"
                        height="500px"
                      />
                    </div>
                    <div className="card-title">{card.title}</div>
                    <div className="card-description">{card.description}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Consultation Section */}
      <section className="consultation">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="consultation-container">
                <img
                  className="consultation-image"
                  src={acf.consultation_image.url}
                  alt="consultation image"
                  width="500px"
                  height="500px"
                />
                <div className="consultation-text-container">
                  <div className="consultation-title">
                    {acf.consultation_title.slice(0, 18)}
                    <br />
                    {acf.consultation_title.slice(18)}
                  </div>
                  <img
                    className="consultation-image-small"
                    src={acf.consultation_image.url}
                    alt="consultation image small"
                    width="500px"
                    height="500px"
                  />
                  {acf.consultation_services.map((service, index) => (
                    <div className="consultation-step" key={index}>
                      <span className="consultation-counter">{index + 1}</span>
                      <div className="consultation-description">
                        {index !== 2 ? (
                          service.description
                        ) : (
                          <>
                            <div className="consultation-description-subtext">
                              {service.description.slice(0, 21)}
                            </div>
                            <div className="consultation-description-subtext">
                              {service.description.slice(22)}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                  <div className="consultation-button-container">
                    <button
                      type="button"
                      className="btn btn-primary text-transform-none"
                      onClick={buttonAction}
                    >
                      {acf.consultation_cta_text}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <Testimonials items={acf.testimonials} isPayroll={true} />
      {/* <section className="testimonials">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="testimonials-container">
                {acf.testimonials.map((testimonial, index) => (
                  <div className="testimonial-section" key={index}>
                    <img className="testimonial-image" src={testimonial.image.url} />
                    <div className="testimonial-title">{testimonial.title}</div>
                    <div className="testimonial-quote">{testimonial.quote}</div>
                    <div className="testimonial-attribution">{testimonial.attribution}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* How It Works Section */}
      <section className="hiw">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="hiw-container">
                <div className="hiw-title">
                  Fast, affordable payroll services for small business
                </div>
                {acf.how_it_works.sections.map((section, index) => (
                  <div className="hiw-section" key={index}>
                    <div className="hiw-image-container">
                      <img
                        className="hiw-image"
                        src={section.illustration.url}
                        alt="how it works image"
                        width="500px"
                        height="500px"
                      />
                    </div>
                    <div className="hiw-text-container">
                      <div
                        className="hiw-text"
                        dangerouslySetInnerHTML={{
                          __html: sanitizeHtml(
                            section.content,
                            sanitizeSettings
                          ),
                        }}
                      />
                      {section.cta_button_text && (
                        <div className="button-container">
                          <button
                            type="button"
                            className="btn btn-primary text-transform-none"
                            onClick={buttonAction}
                          >
                            {section.cta_button_text}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section className="what-you-get">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2>{what_you_get.title}</h2>
              <div className="row">
                <div className="cards-container">
                  {what_you_get.tiles.map((tile, index) => (
                    <div className="card" key={index}>
                      <img
                        src={tile.image}
                        alt="icon"
                        width="500px"
                        height="500px"
                      />
                      <div className="title">
                        <h3>{tile.title}</h3>
                      </div>
                      <div className="card-body pb-0 px-0">
                        <p>{tile.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="blog">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2>{acf.lp_benefits.title}</h2>
              <div className="blog-cards-container">
                {blogModuleData.map((card, index) => (
                  <div className="blog-card" key={index}>
                    <img
                      src={card._embedded['wp:featuredmedia'][0].source_url}
                      alt={card._embedded['wp:featuredmedia'][0].alt_text}
                      width="500px"
                      height="500px"
                    />
                    <div className="title">
                      <Link href={card.link}>
                        <h3 className="product-title"
                          dangerouslySetInnerHTML={{ __html: sanitizeHtml(card.title.rendered, sanitizeSettings) }} />
                      </Link>
                    </div>
                    <div
                      className="card-body pb-0 px-0"
                      dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(card.excerpt.rendered, sanitizeSettings),
                      }}
                    />
                    <Link href={card.link}>
                      <a className="blog-link">{acf.lp_benefits.button_text}</a>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faqs">
        <FaqComponent title={faqs.title} faqs={faqs.questions} />
      </section>

      {/* Contact Section */}
      <section className="contact">
        <div className="container">
          <div className="contact-title">Talk to 1-800Accountant.</div>
          <div className="contact-subtitle">Say hello to easier payroll.</div>
          <button
            type="button"
            className="btn btn-primary text-transform-none"
            onClick={buttonAction}
          >
            Schedule My Free Call
          </button>
        </div>
      </section>
    </PayrollContentStyles>
  );
};

export default PayrollContentComponent;
